import { ParameterTypeEnum } from '@talos/kyoko';

export const securityRelatedParams: string[] = [
  ParameterTypeEnum.PriceProtection,
  ParameterTypeEnum.UnifiedLiquidity,
  ParameterTypeEnum.ReduceOnly,
  ParameterTypeEnum.ReduceFirst,
];
